import React from "react";

const SubmitIssue = () => {
    return (
        <footer className="max-w-4xl mx-auto px-6 py-6 border-t border-border">
            <p className="text-sm text-muted text-center">
                Found a bug?{' '}
                <a
                    href="https://github.com/SSMLLint/ssmllint-dot-com/issues"
                    className="text-accent hover:underline"
                    target="_blank"
                    rel="noreferrer"
                >
                    Report it on GitHub
                </a>
            </p>
        </footer>
    );
}

export default SubmitIssue
